import React from "react"
import { concatStrings, uniqueId } from "../utilities"
import DfbSymbol from "./dfb_symbol"

const DfbSelect = React.forwardRef((props, ref) => {
  const required = props.required ? { required: true } : {}
  const disabled = props.disabled ? { disabled: true } : {}
  const disabledClass = props.disabled ? "is-disabled" : ""
  const noLabelClass = props.label ? "" : "dfb-select--plain"
  const errorClass = props.error ? "is-invalid" : ""
  const focusedClass = props.focused ? "is-focused" : ""
  const inputId = uniqueId(`${props.idPrefix}-`)
  const label = props.label
  const options = props.options ? props.options : []
  const value = props.value != null ? { value: props.value } : {}
  const placeholder = props.placeholder

  return (
    <div
      className={concatStrings(
        "dfb-Select",
        noLabelClass,
        disabledClass,
        errorClass,
        focusedClass,
        props.add_class
      )}
    >
      <div className="dfb-Select-field">
        <label className="dfb-Select-label" htmlFor={inputId}>
          {label}
        </label>
        <select
          ref={ref}
          className="dfb-Select-select"
          style={{
            color: "inherit",
          }}
          name={props.name}
          id={inputId}
          {...required}
          {...disabled}
          {...value}
          defaultValue={props.placeholder ? "" : undefined}
          onChange={props.onChange}
          onBlur={props.onBlur}
        >
          {props.placeholder && (
            <option className="dfb-Select-option" disabled value="">
              {placeholder}
            </option>
          )}

          {options.map((item, index) => (
            <option
              key={index}
              className="dfb-Select-option"
              value={props.value}
            >
              {item.name}
            </option>
          ))}
        </select>
        <div className="dfb-Select-toggle">
          <DfbSymbol icon_type="dropdown-down" />
        </div>
      </div>
      <p className="dfb-Paragraph dfb-Paragraph--small dfb-Input-errorMessage">
        {props.errorMessage}
      </p>
    </div>
  )
})

DfbSelect.defaultProps = {
  tagName: "select",
  idPrefix: "select",
  required: false,
  disabled: false,
  error: false,
}
export default DfbSelect
